import { Button } from 'components/Button/Button'
import { MyDropdown } from 'components/ReactHookForm/MyDropdown'
import { FC, useEffect, useState } from 'react'
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form'
import { TFunction, useTranslation } from 'react-i18next'
import { defaultEMSNSortForm, EMSNSortForm } from 'models/eMSN'

export interface EMSNSortProps {
  handleSubmit: SubmitHandler<EMSNSortForm>
}

const eMSNDateSortOrderOptionsFactory = (t: TFunction<'eMSNPage'>) => ([
  {
    value: 'ascending',
    label: t('emsn-sort.sort-order.option-labels.oldest-to-newest')
  },
  {
    value: 'descending',
    label: t('emsn-sort.sort-order.option-labels.newest-to-oldest')
  }
])

const eMSNClaimTypeSortOrderOptionsFactory = (t: TFunction<'eMSNPage'>) => ([
  {
    value: 'ascending',
    label: t('emsn-sort.sort-order.option-labels.a-z')
  },
  {
    value: 'descending',
    label: t('emsn-sort.sort-order.option-labels.z-a')
  }
])

/**
 * This component renders as a row using the `ds-l-row` css class
 * @param props
 * @returns
 */
export const EMSNSort: FC<EMSNSortProps> = ({ handleSubmit }) => {
  const { t } = useTranslation('eMSNPage')
  const formMethods = useForm<EMSNSortForm>({
    defaultValues: defaultEMSNSortForm,
    shouldFocusError: false
  })

  const { watch } = formMethods
  const sortByWatch = watch('sortBy')
  const [sortOptions, setSortOptions] = useState(eMSNDateSortOrderOptionsFactory(t))

  useEffect(() => {
    if (sortByWatch === 'claimType') {
      setSortOptions(eMSNClaimTypeSortOrderOptionsFactory(t))
    } else {
      setSortOptions(eMSNDateSortOrderOptionsFactory(t))
    }
  }, [sortByWatch, t, setSortOptions])

  return (
      <FormProvider {...formMethods}>
        <form
          onSubmit={formMethods.handleSubmit(handleSubmit)}
          className='ds-l-form-row ds-u-align-items--center'
        >
          <div className='ds-l-col--12 ds-l-sm-col--4'>
            <MyDropdown
              label={t('emsn-sort.sort-by.label')}
              labelClassName='my-u-mt--4'
              name='sortBy'
              options={[
                { value: 'eMSNDate', label: t('emsn-sort.sort-by.option-labels.emsn-date') },
                { value: 'claimType', label: t('emsn-sort.sort-by.option-labels.claim-type') }
              ]}
            />
          </div>
          <div className='ds-l-col--12 ds-l-sm-col--5'>
            <MyDropdown
              label={t('emsn-sort.sort-order.label')}
              labelClassName='my-u-mt--4'
              name='sortOrder'
              options={sortOptions}
            />
          </div>
          <div className='ds-l-col--6  ds-l-sm-col--3 ds-l-md-col--auto'>
            <Button
              type='submit'
              className={`
                ds-c-button
                ds-c-button--solid
                ds-c-button--alternate
                my-u-py--8
                my-u-px--16
                my-u-mt--4
                my-u-sm-mt--16  
                my-u-width--full`}
            >
              {t('emsn-sort.sort-button-text')}
            </Button>
          </div>
        </form>
      </FormProvider>
  )
}
